export default __webpack_public_path__ + "static/media/card-face.a8ebc49d.png";